import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PostBlob, Post } from '@/api/api-middleware';
import { apiPath } from '@/constants/defaultValues';
import { downloadFile, openFileInNewTab } from '@/helpers/Utils';

const initialState = {
  loading: false,
  error: '',
};

export const GetPromotionListReport = createAsyncThunk(
  'EmployeeReport/GetPromotionListReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/EmployeePromotionListReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const EmployeeLocationStatusReport = createAsyncThunk(
  'EmployeeReport/EmployeeLocationStatusReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/EmployeeLocationStatusReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const EmployeeProbationPeriodReport = createAsyncThunk(
  'EmployeeReport/EmployeeProbationPeriodReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/EmployeeProbationPeriodReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const EmployeeAgeGroupReport = createAsyncThunk(
  'EmployeeReport/EmployeeAgeGroupReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/EmployeeAgeGroupReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const DEDSurveyReport = createAsyncThunk(
  'EmployeeReport/DEDSurveyReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/EmployeeDED_SurveyReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const StudyCaseListReport = createAsyncThunk(
  'EmployeeReport/StudyCaseListReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/EmployeeStudyCaseListReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const EmployeeFullDataReport = createAsyncThunk(
  'EmployeeReport/EmployeeFullDataReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/EmployeeFullDataReport'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const EmployeePerformanceEvaluationPerYear = createAsyncThunk(
  'EmployeeReport/EmployeePerformanceEvaluationPerYear',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/PerformanceEvaluationPerYear'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const DepartmentSectionLevelReport = createAsyncThunk(
  'EmployeeReport/DepartmentSectionLevelReport',
  async (params, thunkAPI) => {
    try {
      const url = `${apiPath}${'api/Reporting/DepartmentSectionLevel'}`;
      if (params?.responseType !== 3) {
        const response = await PostBlob({
          url: url,
          data: params,
        });
        params?.responseType === 1
          ? openFileInNewTab(response)
          : downloadFile(response);
      } else {
        const response = await Post({
          url: url,
          data: params,
        });
        return response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
const employeeReportSlice = createSlice({
  name: 'EmployeeReport',
  initialState,
  reducers: {
    clearCurrentItem: (state) => {
      state.AttendanceReportData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetPromotionListReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPromotionListReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(GetPromotionListReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(EmployeeLocationStatusReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(EmployeeLocationStatusReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(EmployeeLocationStatusReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(StudyCaseListReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(StudyCaseListReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(StudyCaseListReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(DEDSurveyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(DEDSurveyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(DEDSurveyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });
    builder
      .addCase(EmployeeAgeGroupReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(EmployeeAgeGroupReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(EmployeeAgeGroupReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(EmployeeProbationPeriodReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(EmployeeProbationPeriodReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(EmployeeProbationPeriodReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });
    builder
      .addCase(EmployeeFullDataReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(EmployeeFullDataReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(EmployeeFullDataReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(EmployeePerformanceEvaluationPerYear.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        EmployeePerformanceEvaluationPerYear.fulfilled,
        (state, action) => {
          state.loading = false;
          state.error = '';
        }
      )
      .addCase(
        EmployeePerformanceEvaluationPerYear.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload ?? 'An error occurred';
        }
      );
    builder
      .addCase(DepartmentSectionLevelReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(DepartmentSectionLevelReport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = '';
      })
      .addCase(DepartmentSectionLevelReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });
  },
});
export default employeeReportSlice.reducer;
